import { Component, OnInit } from '@angular/core';
import {AccountService} from "@app/services";

@Component({
  selector: 'app-menu-left',
  templateUrl: './menu-left.component.html',
  styleUrls: ['./menu-left.component.sass']
})
export class MenuLeftComponent implements OnInit {

  public innerWidth: any;
  public sidebarExpanded = true;

  constructor(
    private accountService: AccountService
  ) { }

  logout():void {
    this.accountService.logout()
  }

  ngOnInit(): void {

    this.innerWidth = window.innerWidth;

    if ( this.innerWidth < 1140) {
      this.sidebarExpanded = false;
      console.log("less", this.innerWidth);
    }
    else {
        /* Set the width of the side navigation to 250px and the left margin of the page content to 250px */
        console.log("more", this.innerWidth);
        this.sidebarExpanded = true;
      }
  }
  // closeNav(){
  //   this.sidebarExpanded = false;
  // }
  // openNav(){
  //   this.sidebarExpanded = true;
  // }

  // openNavless1140() {
  //   angular.element( document.getElementById('someElement') )
  //   document.getElementById("mySidenav").style.width = "250px";
  //   document.getElementById("main").style.marginLeft = "0px";
  //   var btn = document.getElementById("btn-opn-left-menu");
  //   btn.classList.remove("d-flex");
  //   btn.classList.add("d-none");
  // }

  // CloseNavless1140() {
  //   document.getElementById("mySidenav").style.width = "0";
  //   document.getElementById("main").style.marginLeft = "0";
  //   var btn = document.getElementById("btn-opn-left-menu");
  //   btn.classList.remove("d-none");
  // }

  // openNavmore1140() {
  //   document.getElementById("mySidenav").style.width = "250px";
  //   document.getElementById("main").style.marginLeft = "250px";
  //   var btn = document.getElementById("btn-opn-left-menu");
  //   btn.classList.add("d-xl-none");
  // }

  // closeNavmore1140() {
  //   document.getElementById("mySidenav").style.width = "0";
  //   document.getElementById("main").style.marginLeft = "0";
  //   var btn = document.getElementById("btn-opn-left-menu");
  //   btn.classList.remove("d-xl-none");
  // }

}
